module.exports = __webpack_public_path__ + "img/ranking_2.fa66b09d.png";